import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface DeleteGLCodeRequest {
  glCdIds: number[];
}

const useDeleteGLCodeApi = (companyId: string) => {
  const call = useCallback(
    async (params?: DeleteGLCodeRequest) => {
      try {
        const res = await axiosInstance.post(api.deleteGLCode(companyId), params?.glCdIds);
        return res.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId]
  );

  const { isLoading, execute, status } = useAsync(call, false);

  return {
    isLoading,
    deleteGlCode: execute,
    deleteGlCodeStatus: status,
  };
};

export default useDeleteGLCodeApi;
